import tenantApi from '@/api/tenant'

const tenant={
  namespaced:true,
  state:{
    data:[],
    pagination:{current:1,total:0,pageSize:10,showSizeChanger:true,showTotal:total=>`总计 ${total} 条`},
    loading:false,
    editTenant:{},
    editions:[],
    sorter:{}
  },
  mutations:{
    setData:(state,data)=>{
      state.data=data
    },
    setPagination:(state,pagination)=>{
      state.pagination=pagination
    },
    setLoading:(state,loading)=>{
      state.loading=loading
    },
    edit:(state,tenant)=>{
      state.disabled=false
      state.editTenant=tenant
    },
    setEditions:(state,editions)=>{
      state.editions=editions
    },
    setSorter:(state,sorter)=>{
      state.sorter=sorter
    }
  },
  actions:{
    getAll({ commit,state },pagination){
      commit('setLoading',true)
      const page={
        skipCount:pagination.pageSize*(pagination.current-1),
        maxResultCount:pagination.pageSize,
        ...pagination
      }           
      if(state.sorter.field){
        if(state.sorter.order==='ascend'){
          page.sorting=state.sorter.field
        }else{
          page.sorting=state.sorter.field+' desc'
        }
      } 
      tenantApi.getAll(page).then((res)=>{
        commit('setLoading',false)
        pagination.total=res.result.totalCount
        commit('setPagination',pagination)
        commit('setData',res.result.items)
      }).catch(()=>{
        commit('setLoading',false)
      })
    },
    updateOrAdd({ commit,dispatch,state },tenant){
      return new Promise((resolve, reject)=>{
        if(tenant.id){
          tenantApi.update(tenant).then(async res=>{
            resolve(res)
            commit('edit',{})
            await dispatch('getAll',state.pagination)
          }).catch((error)=>{
            reject(error)
          })
        }else{
          tenantApi.create(tenant).then( async res=>{
            resolve(res)
            commit('edit',{})
            await dispatch('getAll',state.pagination)
          }).catch((error)=>{
            reject(error)
          })
        }        
      })      
    },
    getEditions({ commit }){
      tenantApi.getEditions().then(res=>{
        commit('setEditions',res.result.items)
      })
    },
    async disabled({dispatch,state},tenant){
      await tenantApi.disabled({id:tenant.id})
      await dispatch('getAll',state.pagination)
    },
    async active({dispatch,state},tenant){
      await tenantApi.active({id:tenant.id})
      await dispatch('getAll',state.pagination)
    }
  }
}
export default tenant